var map = {
	"./africa_animals.jpg": 6584,
	"./africa_desert.jpg": 3132,
	"./arkhyz.jpg": 9164,
	"./dagestan.jpg": 1752,
	"./elbrus.jpg": 5388,
	"./france.jpg": 1624,
	"./italy.jpg": 7712,
	"./kamchatka_hike.jpg": 1232,
	"./kamchatka_surf.jpg": 9844,
	"./khibiny.jpg": 3555,
	"./lofotens.jpg": 972
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1628;